export const setCurrencyAction = (currency='€') => (dispatch) => {
    dispatch({
        type: "SET_CURRENCY",
        payload: {
            currency: currency
        }
    })
};